// extracted by mini-css-extract-plugin
export var dropdown = "_ux-0";
export var imageWrapper = "_ux-3";
export var itemNameContainer = "_ux-1";
export var productImage = "_ux-2";
export var spinnerWrapper = "_ux-4";